import { useContainerItems, useEventGroup } from 'modules/common/hooks/index.js';
import SportGroupsListView from './view/index.js';
import MojitoServices from 'mojito/services';
const SportUtils = MojitoServices.SportsContent.Sports.utils;

const SportGroupsListController = ({
    sportId,
    groupId,
    type,
    pageType,
    onDataLoad,
    mojitoTools,
    class: className,
}) => {
    const { config } = mojitoTools;
    const baseSportGroups = useContainerItems(groupId);
    const eventGroups = useEventGroup(groupId);
    const racingSportGroups = eventGroups?.map(
        ({ id, countryCode, events, typeName, canonicalTypeName }) => ({
            id,
            countryCode,
            canonicalName: canonicalTypeName,
            items: events,
            name: typeName,
        })
    );

    const sportGroups = SportUtils.isRacingSport(sportId) ? racingSportGroups : baseSportGroups;

    return (
        <SportGroupsListView
            class={className}
            sportId={sportId}
            sportGroups={sportGroups}
            type={type}
            pageType={pageType}
            config={config.sportGroupsListView}
            groupId={groupId}
            onDataLoad={onDataLoad}
        />
    );
};

export default SportGroupsListController;
